// extracted by mini-css-extract-plugin
module.exports = {"olElement":"list_olElement__gu_GV","main":"list_main__T77WQ","disc":"list_disc___muyT","circle":"list_circle__yv1c6","large":"list_large__cj7Cc"};